<template>
    <div>
        <router-view></router-view>
        <vue-tour></vue-tour>
    </div>
</template>


<script>
    import VueTour from "@/components/OnBoarding/VueTour";
    import PwaIosAddToHomescreenBanner from "@/components/Pwa/PwaIosAddToHomescreenBanner";
    export default {
        name: 'BlankLayout',
        components: {
            VueTour
        },
    };
</script>